import React from 'react';
import {Form, FormGroup, Col, Row} from 'react-bootstrap';
import LoadingSpinner from '../LoadingSpinner';

class OrderContactInfo extends React.Component {
    render() {
        const data = this.props.orderContact === undefined ? {} : this.props.orderContact;


        if(this.props.orderContact === undefined)
        {
            return (<div className="height180"><LoadingSpinner isLoading={true}/></div>)
        }
        else
        {
            const RegisteredUser = data.RegistrationUser && data.RegistrationUser.length > 0 ? data.RegistrationUser : "-";
            const ModificationUser = data.ModificationUser && data.ModificationUser.length > 0 ? data.ModificationUser : "-";
            return (
                <Col sm={12}>
                    <Form horizontal autoComplete="off" onSubmit={evt => {evt.preventDefault(); }} style={{"width" : "1800px"}}>
                        <FormGroup>
                            <Row className="row-eq-height">
                                <Col xs={1}>
                                    <Row><Col x={8}>Registered by: </Col></Row>
                                    <Row><Col x={8}>Last modified by: </Col></Row>
                                </Col>
                                <Col xs={3}>
                                    <Row><Col x={3}>{RegisteredUser}</Col></Row>
                                    <Row><Col x={3}>{ModificationUser}</Col></Row>
                                </Col>
                            </Row>
                        </FormGroup>
                    </Form>
                </Col>
            );
        }
    }
}


export default OrderContactInfo;